import React from 'react'
import MaterialSymbol from '../material-symbol'

const Close = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="close" {...props} />
))

Close.displayName = 'Close'

export default Close
